<template>
  <DialogDescription class="half-sheet-container">
    <BundleSummary />
  </DialogDescription>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { DialogDescription } from '@headlessui/vue'
import BundleSummary from './bundle-summary.vue'

onMounted(() => {
  window.dataLayer?.push({
    event: 'page_view',
    pageTitle: 'MiniCart'
  })
})
</script>
